
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epoch",
      function () {
        return require("private-next-pages/epoch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epoch"])
      });
    }
  